import {NgModule} from "@angular/core";
import {RouterModule, Routes} from '@angular/router';
import {MaintimelineviewComponent} from "./components/timeline/maintimelineview/maintimelineview.component";
import {MaintreeeditorviewComponent} from "./components/treeeditor/maintreeeditorview/maintreeeditorview.component";
import {
  MainreportengineviewComponent
} from "./components/reportengine/mainreportengineview/mainreportengineview.component";
import {MultimedialistComponent} from './components/multimedialist/multimedialist.component';
import {EventsTempComponent} from './components/events-temp/events-temp.component';
import {FamilyEditorMainComponent} from "./components/familyeditor/family-editor-main/family-editor-main.component";
import {
  IndividualEditorMainComponent
} from "./components/individualeditor/individual-editor-main/individual-editor-main.component";
import {TreeManagerMainComponent} from "./components/treemanager/tree-manager-main/tree-manager-main.component";
import {canDeactivateGuard} from './services/route-guard';
import {ReportTemplateComponent} from './templates/report/report-template.component';
import {EditorTemplateComponent} from './templates/editor/editor-template.component';
import {routeResolver} from './services/route-resolver';
import {MenuItemComponent} from './components/menu/menu-item/menu-item.component';
import {HomeComponent} from "./components/common/home/home.component";
import {ReportengineTemplateComponent} from "./templates/reportengine-template/reportengine-template.component";
import {ReportManagerMainComponent} from './components/reportmanager/report-manager-main/report-manager-main.component';
import {
  FamilyProjectMainComponent
} from './components/familyprojectmanager/family-project-main/family-project-main.component';
import {DashboardComponent} from "./components/newdashboard/dashboard/dashboard.component";
import {BookReportEngineComponent} from "./components/bookreportengine/book-report-engine/book-report-engine.component";
import {MapReportMainComponent} from "./components/reports/mapreport/map-report-main/map-report-main.component";
import {SourceNewComponent} from "./components/common/source/source-new/source-new.component";
import {PlaceEditorPageComponent} from "./components/common/place/place-editor-page/place-editor-page.component";
import {
  HistoryComponent
} from "@components/mainmenu/reports-menu/ai-reports/ai-reports-sub-menu/history/history.component";
import {ChatComponent} from "@components/mainmenu/reports-menu/ai-reports/ai-reports-sub-menu/chat/chat.component";
import {AiReportsComponent} from "@components/mainmenu/reports-menu/ai-reports/ai-reports.component";
import { AdminSupportDashboardComponent } from './components/admin-support-dashboard/admin-support-dashboard.component';
import { adminGuard } from './services/route-guard';

export const AI_ROUTE_CONST = {
	PATH_DESIGNER: 'designer',
	PATH_EXPLORER: 'explorer',
	PATH_ENTRY_PROMPTS: 'chats',
	PATH_HISTORY: 'history',
	PATH_CHAT: 'chat',

	ENTRY_PROMPTS: {
		FOLDER: 'assets/entry-prompts',
		INDEX: 'assets/entry-prompts/index.json',
		PROMPT: 'prompt.md',
		PREVIEW: 'preview.png',
	},

	PARAMS: {
		PERSON_ID: 'personId',
		ENTRY_PROMPT_ID: 'entryPromptId',
		THREAD_ID: 'threadId',
	},
};

const routes: Routes = [
  {
    path: 'treemanager',
    component: TreeManagerMainComponent
  },
  {
    path: 'timeLine',
    component: MaintimelineviewComponent
  },
  {
    path: 'Editor',
    redirectTo: 'report/treeeditor',
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'multimediaList',
    component: MultimedialistComponent
  },
  {
    path: "reportengine",
    component: ReportengineTemplateComponent,
    children: [
      { path: ":name", component: MainreportengineviewComponent, canDeactivate: [canDeactivateGuard] }
    ],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: "eventTemp",
    component: EventsTempComponent
  },

  //New routes
  {
    path: "report",
    component: ReportTemplateComponent,
    children: [
      {
        path: "treeeditor/:id/:isBreadcrumbUpdate",
        //path: "treeeditor, change @EM-10562
        component: MaintreeeditorviewComponent, canDeactivate: [canDeactivateGuard]
      }
    ],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: "editor",
    component: EditorTemplateComponent,
    children: [
      {
        path: "individualeditor/:id/:isBreadcrumbUpdate",
        //path: "individualeditor", change @EM-10562
        component: IndividualEditorMainComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: { items: routeResolver },
      },
      {
        path: "familyeditor/:id/:isBreadcrumbUpdate",
        //path: "familyeditor", change @EM-10562
        component: FamilyEditorMainComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: { items: routeResolver }
      },
       {
        path: "sourceeditor",
        component: SourceNewComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: { items: routeResolver }
      },
      {
        path: "placeeditorpage",
        component: PlaceEditorPageComponent,
        canDeactivate: [canDeactivateGuard],
        resolve: { items: routeResolver }
      }
    ],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: 'commomList/:name',
    component: MenuItemComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'reportmanager',
    component: ReportManagerMainComponent
  },
  {
    path: 'familyprojectmanager',
    component: FamilyProjectMainComponent
  },
  {
    path: "dashboard",
    component: DashboardComponent
  },
  {
    path: "admin/support",
    component: AdminSupportDashboardComponent,
    canActivate: [adminGuard]
  },
  {
    path: "bookreportengine/:name",
    component: BookReportEngineComponent,
    canDeactivate: [canDeactivateGuard]
  },
  {
    path: "mapreport",
    component: MapReportMainComponent,
  },
  {
    path: "oldmapreport",
    component: MapReportMainComponent,
  },
  {
    path: 'ai',
    component: AiReportsComponent,
    children: [
      {
        path: AI_ROUTE_CONST.PATH_HISTORY,
        title: 'AI history',
        component: HistoryComponent,
      },
      {
        path: AI_ROUTE_CONST.PATH_CHAT,
        title: 'AI chat',
        component: ChatComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
